export default __webpack_public_path__ + "static/media/developer.f86870cb.png";